import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import type { OrderRatingDetail } from 'api/orderRatings.types'
import DetailPanel from 'components/DetailPanel'
import FieldGrid, { FieldGridItem } from 'components/FieldGrid'
import OrderSummaryStrip from 'components/OrderSummaryStrip'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('order_ratings.rating_detail')

type Props = {
  items: FieldGridItem[]
  // The live order snapshot, or null. Null is normal (the order was never
  // captured); a failed fetch is `showOrderError`, distinct from a quiet miss.
  order: OrderRatingDetail['order']
  showOrderError: boolean
  showOrderUnavailable: boolean
  onRetryOrder: () => void
}

// The Case details card: the date/location field grid plus the order-summary
// strip, with the two mutually-exclusive order states (failed fetch vs settled
// with no snapshot) below it.
const CaseDetailsCard = ({
  items,
  order,
  showOrderError,
  showOrderUnavailable,
  onRetryOrder,
}: Props) => {
  const [css] = useStyletron()

  return (
    <DetailPanel>
      <Text.Header4>{t('details.heading')}</Text.Header4>
      <div className={css({ marginTop: '12px' })}>
        <FieldGrid items={items} ariaLabel={t('details.heading')} />
      </div>
      <div className={css({ marginTop: '16px' })}>
        {order && <OrderSummaryStrip order={order} variant="order-rating" />}
        {showOrderError && (
          <>
            <Text.BodyText5 color="grey50">{t('order_error')}</Text.BodyText5>
            <div className={css({ marginTop: '8px' })}>
              <Button kind="secondary" onClick={onRetryOrder}>
                {t('retry')}
              </Button>
            </div>
          </>
        )}
        {showOrderUnavailable && (
          <Text.BodyText5 color="grey50">
            {t('order_unavailable')}
          </Text.BodyText5>
        )}
      </div>
    </DetailPanel>
  )
}

export default CaseDetailsCard
